import {
    generateAiSessionNote,
    markAiNoteStreamDone,
    markAiNoteStreamError,
    resetAiSessionNote,
} from './aiNote.action';

export { aiNoteReducer } from './aiNote.reducer';
export { watchAiNote } from './aiNote.saga';
export {
    GENERATE_AI_SESSION_NOTE,
    GENERATE_AI_SESSION_NOTE_SUCCESS,
    GENERATE_AI_SESSION_NOTE_FAIL,
} from './aiNote.type';

export const aiNoteActions = {
    generateAiSessionNote,
    resetAiSessionNote,
    markAiNoteStreamDone,
    markAiNoteStreamError,
};
